import logo from './logo.svg';
import './App.css';
import {Routes, Route} from 'react-router-dom';
import HomePage from './routes/homepage/home.component';
import {Component} from 'react';
import { useContext } from 'react';
import ActualPlay from './routes/actualplay/actualplay.component';
import CraftCreations from './routes/craftcreations/craftcreations.component';
import ProgrammingProjects from './routes/programmingprojects/programmingprojects.component';
import AboutPage from './routes/aboutpage/about.component';
import FallEnglishBreggfest from './routes/fallenglishbreggfast/fall-english-breggfast.component';
import Alchemy from './routes/alchemy/alchemy.component';
import Oozefestation from './routes/oozefestation/oozefestation.component';
import MaidRPG from './routes/maidrpg/maid-rpg.component';
import ResponsiveWeb from './routes/responsiveweb/responsive-web.component';
import ContactMeComponent from './contactme/contactme.component';
import EpiphanyDice from './routes/epiphanydice/epiphany-dice.component';

const App = () => {
  return (
    <Routes>
  
      <Route index element={<HomePage/>}></Route>
      <Route path="/programming-projects/maidrpg" element={<MaidRPG/>}></Route>
      <Route path="/programming-projects/responsiveweb" element={<ResponsiveWeb/>}></Route>
      <Route path="/programming-projects/oozefestation" element={<Oozefestation/>}></Route>
      <Route path="/programming-projects/alchemy" element={<Alchemy/>}></Route>
      <Route path="/actual-play" element={<ActualPlay/>}></Route>
      <Route path="/craft-creations" element={<CraftCreations/>}></Route>
      <Route path="/programming-projects" element={<ProgrammingProjects/>}></Route>
      <Route path="/about-me" element={<AboutPage/>}></Route>
      <Route path="/programming-projects/fall-english-breggfest" element={<FallEnglishBreggfest/>}></Route>
      <Route path="/contact" element={<ContactMeComponent/>}> </Route>
      <Route path="/programming-projects/epiphany-dice" element={<EpiphanyDice/>}></Route>

    </Routes>
  );
}

export default App;
